/** @file A world offset projected to a screen offset (px, y down) and a view depth (units, grows away). */
import { projectOrtho } from '@zilo/pose3d-math/project/projectOrtho';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { View } from '@zilo/pose3d-render-core/camera/viewOf';

/** One projection per view kind; a new kind is a type error until it has an entry (15.11). */
const BY_KIND: { [K in View['kind']]: (v: Vec3, view: Extract<View, { kind: K }>) => Vec3 } = {
  ortho: (v, view) => projectOrtho([v[0], v[1], v[2] * view.zScaleView], view.basis, view.pixelsPerUnit),
};

/** `[sx, sy, depth]` of the offset `v`; world z is scaled by `zScaleView` (17.7) before the projection. */
export function projectOffset(v: Vec3, view: View): Vec3 {
  return BY_KIND[view.kind](v, view);
}
